import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import { ChatWidget, BackToTop } from '../components/ChatAndUtils';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLegalDoc, LegalSections, TranslationNotice } from '../components/LegalTexts';

const Datenschutz = () => {
  const { t } = useTranslation();
  const [forceDe, setForceDe] = useState(false);
  const doc = useLegalDoc('datenschutz', forceDe ? 'de' : undefined);
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Datenschutzerklärung – Kanzlei Nabhan Gäbler & Partner"
        description="Datenschutzerklärung gemäß DSGVO. Informationen zur Verarbeitung Ihrer personenbezogenen Daten auf unserer Website und im Mandantenportal."
        path="/datenschutz"
      />
      <Header />
      <main className="pt-[150px]">
        <section className="bg-[#1B3A5C] text-white py-14 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <div className="absolute top-0 right-0 w-72 h-72 bg-[#b8893d] rounded-full blur-3xl"></div>
          </div>
          <div className="relative max-w-4xl mx-auto px-6 lg:px-10">
            <Link to="/" className="inline-flex items-center gap-1 text-white/70 text-sm hover:text-[#b8893d] mb-4">
              <ArrowLeft className="w-3.5 h-3.5" /> {t('common.back_home', 'Zurück zur Startseite')}
            </Link>
            <div className="inline-flex items-center gap-3 text-[#e0b56a] text-xs tracking-[0.3em] mb-3">
              <span className="w-12 h-px bg-[#b8893d]" />
              DSGVO
            </div>
            <h1 className="font-serif font-light text-4xl md:text-5xl tracking-tight">{t('legal_pages.datenschutz.title')}</h1>
            <p className="text-white/70 text-sm mt-3"><strong>{t('common.stand', 'Stand')}: {doc?.stand || 'Juni 2026'}</strong></p>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-10" data-testid="datenschutz-content">
            <TranslationNotice doc={doc} forceDe={forceDe} setForceDe={setForceDe} testid="datenschutz" />
            {doc ? <LegalSections sections={doc.sections} /> : <p className="text-[#34536b] text-sm italic">Inhalte werden geladen …</p>}
          </div>
        </section>
      </main>
      <Footer />
      <ChatWidget />
      <BackToTop />
    </div>
  );
};

export default Datenschutz;
